export default __webpack_public_path__ + "static/media/tubby.9c06bf82.jpg";